<template>
    <div class="base-agree" :class="{'agree-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">用户协议</div>
            </div>
            <div class="content-auto">
                <div class="tips">
                    <div>为规范网络游戏服务，国家新闻出版署发布《关于防止未成年人沉迷网络游戏的通知》：</div>
                    <div class="mar">一、实行网络游戏用户账号实名注册注册制度</div>
                    <div class="mar">严格实名，所有网络游戏用户均须使用有效身份信息方可进行游戏账号注册</div>
                    <div class="mar">二、严格控制未成年人使用网络游戏时段、时长</div>
                    <div class="mar">每日22时至次日8时，网络游戏企业不得以任何形式为未成年人提供游戏服务，法定节假日每日累计不得超过3小时，其他时间每日累计不得超过1.5小时。</div>
                    <div class="mar">三、规范向未成年人提供付费服务</div>
                    <div class="mar">网络游戏企业不得为未满8周岁的用户提供游戏付费服务。</div>
                    <div class="mar">同一网络游戏企业所提供的游戏付费服务</div>
                    <div class="mar">• 8周岁以上未满16周岁的用户,单次充值金额不得超过50元人民币,每月充值金额累计不得超过200元人民币</div>
                    <div class="mar">• 16周岁以上未满18周岁的用户,单次充值金额不得超过100元人民币,每月充值金额累计不得超过400元人民币</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseAgree'
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-agree {
        width: 864px;
        height: 888px;
        padding-bottom: 60px;
        border-radius: 18px;
        background: rgba(0, 0, 0, 0.8);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s;
        .content {
            height: 100%;
            display: flex;
            flex-direction: column;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                    text-align: center;
                }
            }
            .content-auto {
                flex: 1;
                padding: 0 60px;
                overflow-y: scroll;
                .tips {
                    font-size: 39px;
                    margin: 60px 0 30px;
                }
                .tips .mar {
                    margin-top: 40px;
                }
            }
        }
    }
    // 竖屏css
    .agree-sp {
        width: 1570px;
        height: 1614px;
        padding-bottom: 90px;
        border-radius: 32px;
        .content {
            .header {
                height: 240px;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
            }
            .content-auto {
                padding: 0 90px;
                .tips {
                    font-size: 70px;
                    margin: 90px 0 54px;
                }
                .tips .mar {
                    margin-top: 72px;
                }
            }
        }
    }
</style>